<div class="po-type-form">
    <h6 class="form-section-title">Equipment</h6>
    <div class="row">
        <div class="col-sm-3 col-6 form-group">
            <label for="eqEmCo">EM Co</label>
            <input type="number" class="form-control" [(ngModel)]="item().emCo" name="eqEmCo" id="eqEmCo" />
        </div>
        <div class="col-sm-4 col-6 form-group">
            <label for="eqEquip">Equip</label>
            <input type="text" class="form-control" [(ngModel)]="item().equipment" name="eqEquip" id="eqEquip" />
        </div>
        <div class="col-sm-5 col-12 form-group">
            <label for="eqEquipDesc">Equipment Description</label>
            <input type="text" class="form-control-plaintext" [value]="item().equipmentDescription" id="eqEquipDesc" readonly />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="eqCompType">Comp Type</label>
            <input type="text" class="form-control" [(ngModel)]="item().compType" name="eqCompType" id="eqCompType" />
        </div>
        <div class="col-sm-4 col-6 form-group">
            <label for="eqComponent">Component</label>
            <input type="text" class="form-control" [(ngModel)]="item().component" name="eqComponent" id="eqComponent" />
        </div>
    </div>

    <h6 class="form-section-title mt-3">Cost</h6>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="eqCostCode">Cost Code</label>
            <input type="text" class="form-control" [(ngModel)]="item().costCode" name="eqCostCode" id="eqCostCode" />
        </div>
        <div class="col-sm-3 col-6 form-group">
            <label for="eqCostType">CT</label>
            <input type="number" class="form-control" [(ngModel)]="item().costType" name="eqCostType" id="eqCostType" />
        </div>
    </div>

    <h6 class="form-section-title mt-3">Material</h6>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="eqMaterial">Material</label>
            <input type="text" class="form-control" [(ngModel)]="item().material" name="eqMaterial" id="eqMaterial" />
        </div>
        <div class="col-sm-4 col-6 form-group">
            <label for="eqVendorMat">Vendor Mat</label>
            <input type="text" class="form-control" [(ngModel)]="item().vendorMaterial" name="eqVendorMat" id="eqVendorMat" />
        </div>
        <div class="col-sm-2 col-6 form-group d-flex align-items-end">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" [(ngModel)]="item().receiving" name="eqReceiving" id="eqReceiving" />
                <label class="form-check-label" for="eqReceiving">Receiving</label>
            </div>
        </div>
    </div>

    <app-po-common-fields [item]="item()" [glAccountReadonly]="true"></app-po-common-fields>
</div>
